import {FC} from 'react'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {useAppIntl} from '../../../i18n'

type Props = {
  refresh?(): void
}

const Error500: FC<Props> = ({refresh}) => {
  const {formatMessage} = useAppIntl()

  return (
    <>
      <h1 className='fw-bolder fs-2qx text-gray-900 mb-4'>
        {formatMessage({id: 'common.error500.title'})}
      </h1>

      <div className='fw-semibold fs-6 text-gray-500 mb-7'>
        {formatMessage({id: 'common.error500.message'})}
      </div>

      <div className='mb-11'>
        <img
          src={toAbsoluteUrl('/media/auth/500-error.png')}
          className='mw-100 mh-300px theme-light-show'
          alt=''
        />
        <img
          src={toAbsoluteUrl('/media/auth/500-error-dark.png')}
          className='mw-100 mh-300px theme-dark-show'
          alt=''
        />
      </div>

      {refresh && (
        <div className='mb-0'>
          <button type='button' className='btn btn-sm btn-primary' onClick={refresh}>
            {formatMessage({id: 'common.error500.reload'})}
          </button>
        </div>
      )}
    </>
  )
}

export {Error500}
